import React, { useState, useEffect } from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { m, LazyMotion, domAnimation } from "framer-motion"
import { imgUrlConverter, actionUrlConverter } from '../../util'
import { PriceComponent } from './price'
import axios from 'axios';
import { AppData } from '../../data';

export const YouMayLike = React.memo(() => {

    const [youMayLikeData, setYouMayLikeData ] = useState([])

    const productDetailCrossSells = AppData?.pagecontextdata?.find(data => data.contentType === "crossSells")

    useEffect(() => {
        
        let urlPath  = window.location.pathname;
        urlPath = urlPath?.split("/")
        
        let url = "";
        if(urlPath?.length > 2){
            url = `${process.env.REACT_APP_CACHE_SERVICE_PATH}/api/cacheService/sitemap/${urlPath[2]}/${urlPath[4]}/${urlPath[6]}`
        }
        
        axios.get(url,
          {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(data => {
			let products =  [];
			Object.values(data.data).forEach(items => {
			if (items.products?.length > 0) {
				products.push(...items.products)
				}
			})
			setYouMayLikeData(products) 
          })
    },[])

    let settings = {
        accessibility: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: true,
        dots: false,
        variableWidth: false,
        adaptiveHeight: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2,
                    dots: false,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3.25,
                    slidesToScroll: 3,
                    dots: false,
                    arrows: true,
                    variableWidth: false
                }
            }
        ]
    }

    const container = {
        show: {
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    const product = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                duration: 0.25
            }
        }
    }

    if (productDetailCrossSells && youMayLikeData && Object.keys(youMayLikeData).length > 0) {
        return (
            <LazyMotion features={domAnimation}>
                <div className="product-categories">
                    <div className="row mb-5 mx-2">
                        <div className="h4 pb-2 product-section-heading">{"You May Also Like"}</div>
                        <m.div
                            className="container-fluid"
                            variants={container}
                            initial="hidden"
                            animate="show"
                        >
                            <Slider {...settings} className="carousel">
                                {youMayLikeData.map((productObj, key) =>{
									let productKey = key
                                    settings.arrows = youMayLikeData.length > 6 ? true : false;
                                    return (<m.div
                                        key={`ProductObj-${productKey}`}
                                        className="product"
                                        variants={product}>
                                        <a href={actionUrlConverter(productObj?.actionUrl)} key={productKey}><div className="img"><img height={250} width={220} src={imgUrlConverter(productObj.imageUrl)} alt={productObj?.displayName} /></div></a>
                                        <div>
                                            <a href={actionUrlConverter(productObj?.actionUrl)}>
                                                <div className="product-name-font">{productObj?.displayName}</div>
                                                <PriceComponent data={productObj} />
                                            </a>
                                        </div>
                                    </m.div>)
                                    })

                                }

                            </Slider>
                        </m.div>
                    </div>
                </div>
            </LazyMotion>)
    } else {
        return null
    }
})
